import { Component } from '@angular/core';
import { BidlistInventoryItemComponent } from '../bidlist-inventory-item/bidlist-inventory-item.component';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  TooltipComponent,
  TrackButtonDirective,
  TransportationEstimateComponent,
  TrapFocusComponent
} from 'remarketing-ui-components-lib';
import { FinanceSourcesPopoverComponent } from '../bidlist-inventory-item/finance-sources-popover/finance-sources-popover.component';
import { AutoBidButtonTextPipe } from 'src/vehicles/pipes/auto-bid-status/auto-bid-button-text.pipe';
import { OfferButtonTextPipe } from 'src/vehicles/pipes/offer-button-text/offer-button-text.pipe';
import { BadgeStatusPipe } from 'smartauction-frontend-micro-library';
import { RouterLink } from '@angular/router';
import { PopoverModule } from 'ngx-bootstrap/popover';

@Component({
    selector: '[list-row-inventory-item]',
    templateUrl: './list-row-inventory-item.component.html',
    styleUrls: ['../bidlist-inventory-item/bidlist-inventory-item.component.scss'],
    imports: [
        CommonModule,
        TranslocoDirective,
        TooltipComponent,
        TransportationEstimateComponent,
        FinanceSourcesPopoverComponent,
        TrapFocusComponent,
        AutoBidButtonTextPipe,
        OfferButtonTextPipe,
        BadgeStatusPipe,
        RouterLink,
        PopoverModule,
        TrackButtonDirective
    ]
})
export class ListRowInventoryItemComponent extends BidlistInventoryItemComponent {
  /**
   * Whether the Fees cell carries a figure. `showFeeRows` is the M4.16 addition: under all-in pricing
   * the required fees are inside the price cell already, so this cell falls to its existing `N/A`
   * branch until the vehicle is purchased.
   *
   * The `<td>` and the `<th>` in `common-list` both stay. A row that opted out of rendering its cell
   * would shift every column after it out of line with the header.
   */
  get showFees(): boolean {
    return (
      this.showFeeRows &&
      !(this.taxesPresent() && this.bidItem.buyerOeUuid !== this.organization.oeUuid) &&
      this.hasFeeDetails()
    );
  }

  /**
   * Evaluated once. The parent getter is not a field: it reads salePrice/offerAmount, consults the
   * flag and runs the all-in arithmetic, so asking twice did all of that twice per change detection
   * cycle for every row of the table. Worse than the cost, the two reads were not guaranteed to agree
   * -- a flag or websocket update landing between them would have returned a value the NaN check was
   * never applied to.
   */
  get getTotalPurchasePrice() {
    const total = super.getTotalPurchasePrice;
    return Number.isNaN(total) ? 0 : total;
  }

  /**
   * The list view's single price cell.
   *
   * Falls back to the original `get('currentAmount')` expression rather than to the raw amount, so
   * a row with no amount still formats exactly as it does today. Unlike the card's
   * `displayCurrentAmount`, which can hand `formatCurrency` an `undefined`, this keeps lodash's
   * `'-'` default in the one place the list view relied on it.
   */
  get listViewCurrentAmount(): number | string {
    return this.isDripPricingApplicable && this.dripCurrentAmount !== undefined
      ? this.dripCurrentAmount
      : this.get('currentAmount');
  }
}
